// src/utils/permissions.js
import { useStore } from "vuex";

export default function can(permission) {
  const store = useStore();
  return store.getters.hasPermission(permission);
}

// export function hasRole(role) {
//   const store = useStore()
//   return store.getters.hasRole(role)
// }
